import { useCallback } from 'react';

import { useClearRefinements, useInstantSearch } from 'react-instantsearch';

import { useTracking } from '@change-corgi/core-react/tracking';

type Result = ModelHookResult<
	{
		query: string;
		disableClearFilters: boolean;
	},
	{
		clearFilters: () => void;
	}
>;

export function useNoResultsScreen(): Result {
	const { results } = useInstantSearch();
	const { refine, canRefine } = useClearRefinements();
	const track = useTracking();

	return {
		data: {
			query: results.query || '',
			disableClearFilters: !canRefine,
		},
		actions: {
			clearFilters: useCallback(() => {
				if (canRefine) {
					refine();
					void track('search', { q: results.query || '', context: 'clear_empty_results_button' });
				}
			}, [canRefine, refine, results.query, track]),
		},
	};
}
